import React, { useEffect } from 'react';
import is24Logo from '../../assets/images/portals/is24.png';
import immoweltLogo from '../../assets/images/portals/immowelt.png';
import kleinanzeigenLogo from '../../assets/images/portals/kleinanzeigen.png';
import faviconWhite from '../../assets/images/favicon-white.png';
import './Onboarding.css';

const OnboardingPage = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', {
      send_to: 'AW-123456789/AbCdEfGhI', // TODO: echte Conversion ID aus Google Ads eintragen
      event_callback: function () {
        // eslint-disable-next-line no-console
        console.log('Install erfolgreich getrackt');
      },
    });
  }, []);

  return (
  <main className="ob-page">

    {/* Hero */}
    <div className="ob-hero-card">
      <div className="ob-hero-deco ob-hero-deco-1" />
      <div className="ob-hero-deco ob-hero-deco-2" />
      <div className="ob-hero-icon-wrap">
        <img src={faviconWhite} alt="ImmoSight" style={{ width: 40, height: 40, objectFit: 'contain' }} />
      </div>
      <h1>Fast hast du es geschafft!</h1>
      <p>Dein smarter Begleiter beim Immobilienkauf. Erhalte alle relevanten Kennzahlen direkt auf den Immobilienportalen.</p>
    </div>

    {/* Steps */}
    <p className="ob-section-label">So geht's in 3 Schritten</p>

    <div className="ob-steps-grid">

      {/* Step 1 */}
      <div className="ob-step-card">
        <div className="ob-step-num">1</div>
        <div className="ob-step-icon-box">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#1DB3B3" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c-1.49 0-2.7 1.21-2.7 2.7s1.21 2.7 2.7 2.7H2V19c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7V21H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z" />
          </svg>
        </div>
        <h3>Puzzle-Icon ansteuern</h3>
        <p>Klicke auf das Puzzle-Symbol oben rechts in deiner Browser-Leiste.</p>
      </div>

      {/* Step 2 */}
      <div className="ob-step-card">
        <div className="ob-step-num">2</div>
        <div className="ob-step-icon-box">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="#1DB3B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="17" x2="12" y2="22" />
            <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z" />
          </svg>
        </div>
        <h3>ImmoSight anpinnen</h3>
        <p>Finde ImmoSight in der Liste und klicke auf das Pin-Symbol daneben.</p>
      </div>

      {/* Step 3 */}
      <div className="ob-step-card">
        <div className="ob-step-num">3</div>
        <div className="ob-step-icon-box">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="#1DB3B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
            <polyline points="10 17 15 12 10 7" />
            <line x1="15" y1="12" x2="3" y2="12" />
          </svg>
        </div>
        <h3>Jetzt nur noch anmelden</h3>
        <p>Klicke auf das ImmoSight-Icon, melde dich an&nbsp;– und du kannst loslegen!</p>
      </div>

    </div>

    {/* Portals */}
    <div className="ob-portals-section">
      <p className="ob-portals-label">Unterstützte Portale</p>
      <div className="ob-portals-list">
        <a href="https://www.immobilienscout24.de" target="_blank" rel="noopener noreferrer"
          className="ob-portal-link" title="ImmobilienScout24">
          <img src={is24Logo} alt="ImmobilienScout24" height={72} />
        </a>
        <a href="https://www.immowelt.de" target="_blank" rel="noopener noreferrer"
          className="ob-portal-link" title="Immowelt">
          <img src={immoweltLogo} alt="Immowelt" height={66} />
        </a>
        <a href="https://www.kleinanzeigen.de/s-immobilien/c195" target="_blank" rel="noopener noreferrer"
          className="ob-portal-link" title="Kleinanzeigen">
          <img src={kleinanzeigenLogo} alt="Kleinanzeigen" height={66} />
        </a>
      </div>
    </div>

  </main>
  );
};

export default OnboardingPage;
